// extracted by mini-css-extract-plugin
export default {"simplifiedHeader":"SimplifiedHeader_simplifiedHeader__qHaaH"};